module.exports = __webpack_public_path__ + "img/symbol-sqrt-right.71cfd7d2.png";